import { SwitchButton } from "components/switchButton";
import { Link } from "react-router-dom";
import Button from "components/button";
import { EyeIcon } from "@heroicons/react/outline";
import { getAttractionQRCodeSendingStatus, isHaveActionPermission } from "utills/helpers";
import { IAttractionQRCodeItem } from "interfaces";
import { get } from "lodash";
import { Tag } from "components/tag";
import moment from "moment";

interface AttractionQRCodeCardProps {
  data?: IAttractionQRCodeItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const AttractionQRCodeCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  _toggleActive,
}: AttractionQRCodeCardProps) => {
  return (
    <ul className="bg-white">
      {data.map((item: IAttractionQRCodeItem, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <div className="w-full flex items-center justify-between">
            <SwitchButton
              checked={item.is_active}
              disabled={!isHaveActionPermission("attractions_qr_code", "events", "edit")}
              onChange={() => _toggleActive(item.id, item.is_active)}
            />

            <div className="flex items-center gap-x-[8px]">
              <Link to={`/events/attraction-qr-code/${item.id}`} className="w-fit">
                <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                  <EyeIcon className="w-4 h-4 text-black" />
                </Button>
              </Link>
            </div>
          </div>

          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Code</p>
            <p className="flex-1 text-right text-sm leading-6">
              {get(item, "code", "")}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Ticket name</p>
            <p className="flex-1 text-right text-sm leading-6">
              {get(item, "ticket.name_en", "")}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Event name</p>
            <p className="flex-1 text-right text-sm leading-6">
              {get(item, "event.name_en", "")}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Code sending status</p>
            <Tag text={getAttractionQRCodeSendingStatus(item.status)} type={item.status}  />
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Created date</p>
            <p className="flex-1 text-right text-sm leading-6">
              {item.created_at ? moment(item.created_at).format("DD/MM/YYYY HH:mm:ss") : ""}
            </p>
          </li>
        </div>
      ))}
    </ul>
  );
};
